import * as actionTypes from './leadGenerationNurturingConstants';
import {campaignTemplateService, tagGroupService} from '_app/services';
import {fetchFavoriteMedia} from '_app/mediahub/scenes/LandingPage/FavoriteMedia/favoriteMediaActions';

export const getCampaignTemplates = (selectedPage, isFavorite, selectedCategory = 0) => (dispatch) => {
	dispatch(fetchCampaignTemplatesRequest);

	campaignTemplateService.getPublishedTemplates(selectedPage, isFavorite, selectedCategory)
		.then(response => dispatch(fetchCampaignTemplatesSuccess(response.data, selectedCategory)))
		.catch(error => dispatch(fetchCampaignTemplatesFailure(error)));
};

export const fetchFavoriteCampaignTemplates = (id, isFavorite, selectedFilter, proxiedAsId) => (dispatch) => {
	dispatch(fetchFavoriteCampaignTemplatesRequest);

	campaignTemplateService.fetchFavorite(id, isFavorite)
		.then(response => dispatch(fetchFavoriteCampaignTemplatesSuccess(response.data)))
		.then(dispatch(fetchFavoriteMedia(selectedFilter, proxiedAsId)))
		.catch(error => dispatch(fetchFavoriteCampaignTemplatesFailure(error)));
};

export const getCampaignTemplateById = (id) => (dispatch) => {
	dispatch(fetchCampaignTemplateRequest);

	return campaignTemplateService.get(id)
		.then(response => dispatch(fetchCampaignTemplateSuccess(response.data)))
		.catch(error => dispatch(fetchCampaignTemplateFailure(error)));
};

export const fetchCampaignTemplatesCategories = (sectionId) => (dispatch) => {
	dispatch(fetchCampaignTemplatesCategoriesRequest);

	return tagGroupService.tags(sectionId)
		.then(categories => dispatch(fetchCampaignTemplatesCategoriesSuccess(categories)))
		.catch(error => dispatch(fetchCampaignTemplatesCategoriesFailure(error)));
};

const fetchCampaignTemplateRequest = {
	type: actionTypes.CAMPAIGN_TEMPLATE_FETCH_REQUEST
};

const fetchCampaignTemplateSuccess = campaignTemplate => ({
	type: actionTypes.CAMPAIGN_TEMPLATE_FETCH_SUCCESS,
	campaignTemplate
});

const fetchCampaignTemplateFailure = error => ({
	type: actionTypes.CAMPAIGN_TEMPLATE_FETCH_FAILURE,
	errorInfo: error
});

const fetchCampaignTemplatesRequest = {
	type: actionTypes.CAMPAIGN_TEMPLATES_FETCH_REQUEST
};

const fetchCampaignTemplatesSuccess = (payload, selectedCategory) => ({
	type: actionTypes.CAMPAIGN_TEMPLATES_FETCH_SUCCESS,
	data: {
		hasFilterApplied: !(selectedCategory === 0),
		templates: payload.campaignTemplates
	}
});

const fetchCampaignTemplatesFailure = (error) => ({
	type: actionTypes.CAMPAIGN_TEMPLATES_FETCH_FAILURE,
	errorInfo: error
});

const fetchFavoriteCampaignTemplatesRequest = {
	type: actionTypes.FAVORITE_CAMPAIGN_TEMPLATES_FETCH_REQUEST
};

const fetchFavoriteCampaignTemplatesSuccess = data => ({
	type: actionTypes.FAVORITE_CAMPAIGN_TEMPLATES_FETCH_SUCCESS,
	data
});

const fetchFavoriteCampaignTemplatesFailure = (error) => ({
	type: actionTypes.FAVORITE_CAMPAIGN_TEMPLATES_FETCH_FAILURE,
	errorInfo: error
});

const fetchCampaignTemplatesCategoriesRequest = {
	type: actionTypes.CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_REQUEST
};

const fetchCampaignTemplatesCategoriesSuccess = data => ({
	type: actionTypes.CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_SUCCESS,
	categories: data
});

const fetchCampaignTemplatesCategoriesFailure = error => ({
	type: actionTypes.CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_FAILURE,
	errorInfo : error
});